import * as Yup from 'yup';

export interface IExtraDetails {
  attendance_pin: string;
  extra_fields: IExtraFields;
  blood_group: string;
  is_disable_person: boolean;
  disability?: string;
  is_backward_area: boolean;
}

interface IExtraFields {
  food: string;
  local_contact_person: ILocalContactPerson;
  health_issue: string;
  special_needs: string;
}

interface ILocalContactPerson {
  name: string;
  relationship: string;
  contact_number: string;
}

export const extraDetailsInitialValue = {
  attendance_pin: '',
  extra_fields: {
    food: '',
    health_issue: '',
    special_needs: '',
    local_contact_person: {
      name: '',
      relationship: '',
      contact_number: ''
    }
  },
  blood_group: '',
  is_disable_person: false,
  disability: '',
  is_backward_area: false
};

export const ExtraDetailsValidationSchema = Yup.object().shape({
  attendance_pin: Yup.string().nullable(),
  extra_fields: Yup.object({
    food: Yup.string().required('Food details is required'),
    health_issue: Yup.string().nullable(),
    special_needs: Yup.string().nullable(),
    local_contact_person: Yup.object().shape({
      name: Yup.string().required('Local contact person name is required').nullable(),
      relationship: Yup.string().required('Relation is required').nullable(),
      contact_number: Yup.string().required('Contact number is required').nullable()
    })
  }),
  blood_group: Yup.string().nullable()
});

export const FoodDetails: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Veg',
      value: 'veg'
    },
    {
      label: 'Non Veg',
      value: 'non_veg'
    }
  ];

export const DisabilityOptions: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Deaf',
      value: '1'
    },
    {
      label: 'Physical Disability',
      value: '2'
    },
    {
      label: 'Blind',
      value: '3'
    },
    {
      label: 'Deaf',
      value: '4'
    }
  ];
